import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import { useTranslate } from "react-admin";
var BulkGenerationQuota = function (_a) {
    var remainingQuota = _a.remainingQuota, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var translate = useTranslate();
    return (_jsx(Paper, { variant: "outlined", sx: {
            px: 2,
            py: 1.25,
            borderRadius: 1.5,
            bgcolor: "grey.50",
        }, children: _jsxs(Box, { display: "flex", alignItems: "center", gap: 1.5, children: [_jsx(Typography, { variant: "body2", color: "text.secondary", fontWeight: 600, children: translate("pages.bulkGeneration.quota.label") }), loading ? (_jsx(CircularProgress, { size: 16 })) : (_jsxs(Typography, { variant: "body2", color: "text.primary", fontWeight: 600, children: [remainingQuota !== null && remainingQuota !== void 0 ? remainingQuota : 0, translate("pages.membership.fields.plans.genLeft")] }))] }) }));
};
export default BulkGenerationQuota;
